/*=========================================================================================
  File Name: module-auth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-auth-state';
import mutations from './module-auth-mutations';
import actions from './module-auth-actions';
import getters from './module-auth-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state: state,
	mutations: mutations,
	actions: actions,
	getters: getters
};
